import { put, takeLatest } from "redux-saga/effects";
import { PRODUCT_LIST } from "../constants/actionTypes";
import url from "../api";
import { doListProductsStart, doSetProducts } from "../actions/product";
import { call, select } from "typed-redux-saga";
import { isUserAuthenticated } from "../selectors/user";
import { makeApiCall } from "./general";

function* productSaga(): Generator {
  yield takeLatest(PRODUCT_LIST, handleListProducts);
}

type GetProductsParams = {
  page: number;
  products: any[];
};

function* getProducts({ page, products }: GetProductsParams): Generator {
  const token = yield* select(isUserAuthenticated);
  if (token) {
    const { listProducts } = url;
    const data = yield call(makeApiCall, listProducts(page), null, {
      headers: {
        "ALBAIK-Auth-Token": token,
      },
    });
    if (data && !data.error && !data.errors) {
      const allProducts = [...products, ...data];
      if (data.length === 0) {
        return allProducts;
      } else {
        return yield getProducts({ page: page + 1, products: allProducts });
      }
    } else {
      return [];
    }
  }
}

function* handleListProducts(): Generator {
  yield put(doListProductsStart());
  const data = yield getProducts({
    page: 1,
    products: [],
  });
  yield put(doSetProducts(data));
}

export { handleListProducts };
export default productSaga;
